import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from "vuex";
import { TOGGLE_CAMPAIGN_ACTIVE } from "../store/drip-campaign-actions";
import { GET_MARKETING_EMAILS } from "@Broker/@Modules/marketing/store/marketing/marketing-getters";
import InlineLoader from "@Shared/components/general/inline-loader";
import { showToast } from "@Shared/utils/constants";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { IS_USAGE_RESTRICTED } from "@Broker/@Modules/account-plan/store/account-plan-getters";
import PlanTooltip from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-tooltip.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignActiveToggle",
  components: {
    InlineLoader,
    PlanTooltip
  },
  props: {
    campaignId: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    emailId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("MarketingStore", [GET_MARKETING_EMAILS])), mapState("AccountPlanStore", ["currentPagePlan"])), mapGetters("AccountPlanStore", [IS_USAGE_RESTRICTED])), {}, {
    activeText() {
      return this.active ? this.$t("global.words.active") : this.$t("global.words.inactive");
    },
    activeClass() {
      return `${this.active ? "text-success" : "text-danger"} ${this.disableToggle ? "disabled" : ""}`;
    },
    selectedEmail() {
      var _context;
      return _findInstanceProperty(_context = this.GET_MARKETING_EMAILS).call(_context, email => email.emailId === this.emailId);
    },
    isSelectedEmailVerified() {
      var _this$selectedEmail;
      return (_this$selectedEmail = this.selectedEmail) == null ? void 0 : _this$selectedEmail.verified;
    },
    disableToggle() {
      return this.IS_USAGE_RESTRICTED(this.currentPagePlan) && !this.active;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [TOGGLE_CAMPAIGN_ACTIVE])), mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), {}, {
    async handleToggleActive() {
      if (this.isSelectedEmailVerified || this.active) {
        this.loading = true;
        await this.TOGGLE_CAMPAIGN_ACTIVE(this.campaignId);
        await this.LOAD_PLAN_LIMIT(this.currentPagePlan);
        this.loading = false;
      } else {
        showToast("error", "emailMustBeVerifiedToActivateDripCampaign");
      }
    }
  })
});